import { QueryClient } from '@tanstack/react-query';

/** Ключ кеша счётчиков меню админки — единственный источник для хука запроса и инвалидации */
export const ADMIN_MENU_COUNTERS_QUERY_KEY = [
  'admin',
  'menu-counters'
] as const;

/**
 * Инвалидирует счётчики меню админки после мутаций, меняющих количество необработанного.
 * Живёт в shared, а не в entities: вызывается из мутаций admin-resources,
 * а кросс-импорт entity→entity запрещён FSD-границами.
 * @param queryClient - экземпляр QueryClient
 */
export const invalidateAdminMenuCounters = (queryClient: QueryClient): void => {
  queryClient.invalidateQueries({ queryKey: ADMIN_MENU_COUNTERS_QUERY_KEY });
};
